import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {AuthorizationService} from '../../authorization/authorization.service';

@Injectable()
export class ModeratorTokenInterceptor implements HttpInterceptor {
  constructor(
    protected authorizationService: AuthorizationService,
  ) {
  }

  addToken(request: HttpRequest<any>): HttpRequest<any> {
    const moderatorToken = this.authorizationService.getModeratorToken();
    if (moderatorToken) {
      return request.clone({
        setHeaders: {
          'Moderator-Authorization': `Bearer ${moderatorToken}`,
        },
      });
    }
    return request;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.addToken(request));
  }
}
